import React from "react";
import { Card, Typography, Button, Image } from "antd";
import CLOCK_ICON from "../../../../icons/svg/clock.svg"; // Adjust the import path as necessary
import { convertUtcToLocal } from "../../../../library/utils";
import { formatEmailBodyHtml } from "../../../../utils/htmlHelpers";
import useLang from "../../../../hooks/useLang";
import "../../../../styles/emailBody.css";

const { Text } = Typography;

const ViewOnlyEmail = ({ email, scheduled, cancelScheduledCallback }) => {
  const [lang] = useLang();

  return (
    <>
      {scheduled && (
        <div className="flex bg-grey-200 rounded-[4px] p-2 justify-between items-center mb-4">
          <div className="flex items-center gap-2">
            <Image className="!mb-1" preview={false} src={CLOCK_ICON} />
            <Text className="!text-grey-700 !font-normal !text-sm">
              {lang.sendScheduledFor}{" "}
              {convertUtcToLocal(email?.taskSendDatetime, "DD MMM, YYYY, hh:mm A") || lang.n_a}
            </Text>
          </div>
          <Button
            onClick={() => cancelScheduledCallback(email?.id)}
            type="link"
            className="!font-semibold !text-sm !text-brand-500"
          >
            {lang.cancelSend}
          </Button>
        </div>
      )}
      <div className="border border-solid border-grey-200 rounded-lg">
        <div className="border-b-grey-200 border border-solid border-t-0 border-x-0 p-4">
          <Text className="!m-0" strong>
            {lang.to}:
          </Text>{" "}
          <Text className="!m-0 !ml-2">{email?.to || lang.recipientNotSpecified}</Text>
        </div>
        <div className="border-b-grey-200 border border-solid border-t-0 border-x-0 p-4">
          <Text className="!m-0" strong>
            {lang.subject}:
          </Text>{" "}
          <Text className="!m-0 !ml-2">{email?.subject || lang.noSubject}</Text>
        </div>
        <div className="border p-3 rounded">
          <div
            className="thread-email-body"
            dangerouslySetInnerHTML={{
              __html: formatEmailBodyHtml(email?.body || email?.bodyHtml) || lang.noContent,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ViewOnlyEmail;
